<!--
    VIB-1735 / PRD PH-789 §4.1 & §4.2 (PRD §7.1 / §7.2)
    Blocking popup shown when a post-checkout address change would create a
    Gut Zoomer / Gut Zoomer New York mismatch on an existing order.
    The address is NOT persisted when this fires; copy is cancel-and-replace only
    (no "update anyway" path), with a single [ OK ] button (P1-10).
    Styled to match the repo's confirm-address-dialog siblings (ActionRequiredDialog,
    DuplicatedPatientDialog), including the top-right close icon.

    Props:
      - model-value: controls visibility (v-model)
      - direction: 'non_ny_to_ny'  -> §4.1 (order has Gut Zoomer / Gut Zoomer - Stool Only, address now NY)
                   'ny_to_non_ny'  -> §4.2 (order placed as Gut Zoomer New York, address now non-NY)
      - patient_state: full state name interpolated into the §4.2 copy (e.g. "California")
-->
<template>
    <el-dialog
        :model-value="modelValue"
        top = '10vh'
        class = 'confirm-address-dialog gz-ny-block-dialog'
        :close-on-click-modal="false"
        @update:model-value="(val)=>$emit('update:modelValue', val)"
        @close = "handleDialogClose()"
    >
        <template #header = '{close}'>
            <div class = 'dialog-header-content'>
                <img src = "@/assets/BloodDraw/close_icon.svg" @click="close" class = "close-icon"/>
            </div>
        </template>
        <div class = 'confirm-address-dialog-content'>
            <div class = 'confirm-address-dialog-title'>
                Address change not allowed
            </div>
            <div class = "gz-ny-block-dialog-body">
                {{ body_content }}
            </div>
            <div class = "confirm-ops-btns-div">
                <div class = "confirm-btn" @click="clickOkBtn">OK</div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default{
    props:{
        modelValue:{
            type:Boolean,
            default:false,
        },
        direction:{
            // 'non_ny_to_ny' (§4.1) | 'ny_to_non_ny' (§4.2)
            type:String,
            default:'non_ny_to_ny',
        },
        patient_state:{
            type:String,
            default:'',
        },
    },
    emits:['update:modelValue', 'ok', 'close'],
    computed:{
        body_content(){
            if(this.direction == 'ny_to_non_ny'){
                // §4.2 — order was placed as Gut Zoomer New York, address is now non-NY
                return `This order was placed as Gut Zoomer New York. The patient's address is now in ${this.patient_state}. If you'd like to switch to the standard Gut Zoomer test, please cancel this order and place a new one.`;
            }
            // §4.1 — order contains Gut Zoomer / Gut Zoomer - Stool Only, address is now NY
            return "This order contains Gut Zoomer, which can't be sent to patients in New York. To order Gut Zoomer New York instead, please cancel this order and place a new one with the updated address.";
        },
    },
    methods:{
        clickOkBtn(){
            this.$emit('ok');
            this.$emit('update:modelValue', false);
        },
        handleDialogClose(){
            this.$emit('close');
        },
    }
}
</script>

<!-- Non-scoped: el-dialog teleports to <body>, so the .el-dialog class can't be reached by scoped styles.
     The shared confirm-address-dialog sets min-height:476px (sized for taller dialogs); this short
     block popup overrides it so the dialog hugs its content instead of leaving dead space below. -->
<style>
.el-dialog.confirm-address-dialog.gz-ny-block-dialog{
    /* confirm-address-dialog is sized for large form/summary dialogs; this short confirmation
       gets a compact width + no min-height so it doesn't read as a sparse, oversized box. */
    width: 540px !important;
    min-width: unset !important;
    max-width: calc(100% - 48px);
    min-height: unset;
}
</style>

<style scoped>
/* Mirrors ActionRequiredDialog so the popup matches the repo's confirm-address-dialog convention. */
.dialog-header-content{
    display:flex;
    justify-content:flex-end;
    padding-right:20px;
    padding-top:20px;
    padding-bottom:8px;
}
.close-icon{
    cursor:pointer;
}
.confirm-address-dialog-content{
    padding-left: 40px;
    padding-right:40px;
    padding-bottom:40px;

    display:flex;
    flex-direction:column;
    gap:24px;
}
.confirm-address-dialog-title{
    color: #0E4672;
    font-family: 'Roboto';
    font-size: 24px;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 0.458px;
}
.gz-ny-block-dialog-body{
    color: #0E4672;
    font-family: 'Roboto';
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.458px;
    white-space:pre-wrap;
    word-break: break-word;
}
.confirm-ops-btns-div{
    display:flex;
    justify-content:center;
}
.confirm-btn{
    padding: 13px 0px;
    width:50%;
    min-width:132px;
    border-radius: 4px;
    background:#0E4672;
    text-align:center;

    color: #FFF;
    font-family: 'Roboto';
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.4px;
    cursor:pointer;
}
@media only screen and (max-width: 767px){
    .confirm-address-dialog-content{
        padding-left: 24px;
        padding-right:24px;
        padding-bottom:30px;
        gap:20px;
    }
    .confirm-address-dialog-title{
        font-size: 16px;
        font-weight: 700;
        line-height: 19px;
    }
    .confirm-btn{
        width:100%;
    }
}
</style>
